import { render, staticRenderFns } from "./header-top.vue?vue&type=template&id=2212d70c&scoped=true&"
import script from "./header-top.vue?vue&type=script&lang=js&"
export * from "./header-top.vue?vue&type=script&lang=js&"
import style0 from "./header-top.vue?vue&type=style&index=0&id=2212d70c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212d70c",
  null
  
)

export default component.exports